import { Button, Checkbox, DeleteIcon, GridColumn, GridRow, Input } from '@bp/ui-components';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { CurriculumFormType } from '../../types';

type CurriculumTeachersFormItemProps = {
  index: number;
  onDelete: () => void;
};

export const CurriculumTeachersFormItem = ({ index, onDelete }: CurriculumTeachersFormItemProps) => {
  const { t } = useTranslation();

  const { values, setFieldValue, setFieldTouched } = useFormikContext<CurriculumFormType>();

  return (
    <GridRow spacingBottom='m' spacingTop='none'>
      <GridColumn width={10}>
        <GridRow spacingBottom='none' spacingTop='none'>
          <GridColumn width={10}>
            <Input
              name={`description-${index}`}
              value={values.teachers?.[index].description ?? t('curriculum.subjectTeacher')}
              label={t('common.description')}
              onChange={async (event) => {
                await setFieldValue(`teachers.${index}.description`, event.target.value, true);
                await setFieldTouched(`teachers.${index}.description`, true);
              }}
            />
          </GridColumn>
          <GridColumn width={2} className='mt-3'>
            <Checkbox
              name={`teachingLoad-${index}`}
              checked={!!values.teachers?.[index].teachingLoad}
              label={t('lesson.basics.isTeachingLoadEnabled.full')}
              onChange={async (event) => {
                await setFieldValue(`teachers.${index}.teachingLoad`, event.target.checked, true);
                await setFieldTouched(`teachers.${index}.teachingLoad`, true);
              }}
            />
            <Checkbox
              name={`present-${index}`}
              checked={!!values.teachers?.[index].present}
              label={t('lesson.person.present')}
              onChange={async (event) => {
                await setFieldValue(`teachers.${index}.present`, event.target.checked, true);
                await setFieldTouched(`teachers.${index}.present`, true);
              }}
            />
          </GridColumn>
        </GridRow>
      </GridColumn>
      <GridColumn width={2} className='mt-5' align='end'>
        <Button hierarchy='tertiary' onClick={onDelete} icon={<DeleteIcon />} />
      </GridColumn>
    </GridRow>
  );
};
